import { useEffect, useRef } from 'react';
import { useV3Shell } from './V3ShellContext';

let nextWindowId = 0;

// A window (modal) calls this while it is open: `useV3Modal(isOpen, wantedWidth)`. `wantedWidth` is how wide the window would like to be, in the
// page's own pixels. Inside the V3 shell this registers the window, and if the room between the two side bars is less than that, the
// shell pushes the bars shut to icon strips (they spring back when the window closes or no longer needs the room). Outside the V3 shell
// it does nothing at all. Returns true when the window is inside the V3 shell.
export const useV3Modal = (open, wantedWidth) => {
  const shell = useV3Shell();
  const register = shell ? shell.registerModal : null;
  const idRef = useRef(null);
  if (idRef.current === null) {
    nextWindowId += 1;
    idRef.current = `v3-window-${nextWindowId}`;
  }
  useEffect(() => {
    if (!register || !open) return undefined;
    return register(idRef.current, wantedWidth);
  }, [register, open, wantedWidth]);
  return !!shell;
};

export default useV3Modal;
